import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { Card, CardContent } from '@/components/ui/card';
import { Testimonial, getCategoryInfo } from '@/data/stories/testimonials';

interface StoryCardProps {
  testimonial: Testimonial;
}

export const StoryCard = ({ testimonial }: StoryCardProps) => {
  const categoryInfo = getCategoryInfo(testimonial.category);

  return (
    <Card className={`group hover:shadow-xl transition-all duration-300 border-0 ${categoryInfo.bgColor} relative overflow-hidden`}>
      <div className={`absolute inset-0 bg-gradient-to-br ${categoryInfo.color} opacity-5 group-hover:opacity-10 transition-opacity duration-300`}></div>
      
      <CardContent className="p-6 relative">
        {/* Quote Icon */}
        <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full bg-white shadow-md mb-4 ${categoryInfo.iconColor}`}>
          <ChatBubbleLeftRightIcon className="w-6 h-6" />
        </div>

        {/* Story Title */}
        {testimonial.title && (
          <h3 className="text-lg font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">
            {testimonial.title}
          </h3>
        )}

        {/* Quote */}
        <blockquote className="text-muted-foreground leading-relaxed mb-6 italic">
          "{testimonial.quote}"
        </blockquote>

        {/* Author Info */}
        <div className="flex items-center justify-between pt-4 border-t border-border/50">
          <div>
            <div className="font-medium text-foreground">
              {testimonial.name}
            </div>
            <div className="text-sm text-muted-foreground">
              {testimonial.role}
            </div>
            {testimonial.location && (
              <div className="text-xs text-muted-foreground/80 mt-1">
                {testimonial.location}
              </div>
            )}
          </div>
          
          {/* Category Badge */}
          <div className={`px-3 py-1 rounded-full text-xs font-medium bg-white shadow-sm ${categoryInfo.iconColor}`}>
            {categoryInfo.title.slice(0, -1)}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};